export const SEARCH_RADIUS: number[] = [1,3,5,10,15,20];
export const DEFAULT_SEARCH_RADIUS: number = 20;
export const MAX_RADIUS: number = 20;
